import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "../lib/api";

const SettingsContext = createContext(null);

export const SettingsProvider = ({ children }) => {
  const [sponsorsEnabled, setSponsorsEnabled] = useState(false);
  const [liveEnabled, setLiveEnabled] = useState(false);
  const [liveTitle, setLiveTitle] = useState(null);
  const [liveScheduledAt, setLiveScheduledAt] = useState(null);
  const [loaded, setLoaded] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/settings");
      setSponsorsEnabled(!!data.sponsors_enabled);
      setLiveEnabled(!!data.live_enabled);
      setLiveTitle(data.live_title || null);
      setLiveScheduledAt(data.live_scheduled_at || null);
    } catch (e) {
      /* ignore */
    } finally {
      setLoaded(true);
    }
  }, []);

  useEffect(() => {
    refresh();
    const interval = setInterval(refresh, 60000);
    return () => clearInterval(interval);
  }, [refresh]);

  return (
    <SettingsContext.Provider value={{ sponsorsEnabled, setSponsorsEnabled, liveEnabled, setLiveEnabled, liveTitle, liveScheduledAt, loaded, refresh }}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => useContext(SettingsContext);
